import { Heading, Section } from "@carbon/react";
import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
};

const PageHeader: React.FC<Props> = ({ children, className = "" }) => {
  return (
    <Section level={2}>
      <Heading className={className !== undefined ? className : "ml-0"}>{children}</Heading>
    </Section>
  );
};

export default PageHeader;
